import * as React from 'react';
import { connect } from 'react-redux';
import { editSeller, fetchSeller } from '../../actions/sellersActions';
import { fetchUsuarios, editUsuario, fetchUsuario } from '../../actions/usuariosActions';
import { postSearchTokenUsuario, enlazarMfaUsuarioApi, confirmarMfaApi, postVerificarMfaUsuarioApi } from '../../api/axios';
import { setMfaStatus } from '../../actions/generalActios';
import { Modal } from 'bootstrap';
import { toast } from '../../utilities/appToast';
import PasswordValidation from '../Usuarios/PasswordValidation';
import { IconEye } from '../General/IconEye';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

class MailUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            usuarioError: true,
            token: '',
            showTokenInput: false,
            showPassword: false,
            codigoQR: null,
            codigoDobleAutenticacion: "",
            verificadoMfa: false,
            password: "",
            confirmarPassword: "",
            passValidation: false,
            showPasswordVisible: false,
            showConfirmPasswordVisible: false,
            passwordActual: "",
            tiposUsuario: [],
        };
        this.emailUsuarioInputRef = React.createRef();
        this.modalInstance = null;
        this._lastFindUserTokenKey = null;
    };

    parseResetTokenResponse = (raw) => {
        let res = raw;
        if (typeof raw === "string") {
            try {
                res = JSON.parse(raw);
            } catch {
                res = {};
            }
        }
        const token =
            res?.token ||
            res?.Token ||
            res?.resetToken ||
            res?.ResetToken ||
            res?.tokenResetPassword ||
            "";
        return (token || "").trim();
    };

    componentDidMount() {
        // si tiene idSeller(codigo) estoy editando sino estoy creando
        if (this.props.seller?.codigo) {
            // No llamar fetchTokenUsuario aquí para evitar usar state.usuario rancio.
            // Esperar a que lleguen los usuarios en componentDidUpdate o usar usuarios si ya existen.
            if (this.props.usuarios && this.props.usuarios.length > 0) {
                this.findUserAndFetchToken(this.props.usuarios);
            }
        } else if (!this.props.usuario?.idUsuario && this.props.userId) {
            // Si no hay vendedor ni usuario, pero tenemos userId, buscar el usuario (caso de usuario normal)
            this.props.fetchUsuario({ idUsuario: this.props.userId });
        }

        if (this.emailUsuarioInputRef.current) {
            this.emailUsuarioInputRef.current.focus();
        }

        // Solo verificar MFA del usuario logueado en edición de seller; en alta no aplica (seller aún no existe).
        this.checkVerificaMfa();
        // this.fetchTiposUsuario(); // Ya no es necesario buscar tipos de usuario si siempre es 3

        // Set default User Type to 3 (Seller Admin) if not set
        if (!this.props.seller.idTipoUsuario) {
            let seller = this.props.seller;
            seller.idTipoUsuario = 3;
            this.props.editSeller(seller);
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar si llegaron usuarios nuevos (desde SellerEdit)
        if (this.props.seller?.codigo && this.props.usuarios !== prevProps.usuarios) {
            if (this.props.usuarios && this.props.usuarios.length > 0) {
                this.findUserAndFetchToken(this.props.usuarios);
            }
        }
    }

    checkVerificaMfa = () => {
        if (!this.props.seller?.codigo) {
            return;
        }
        const { userId, mfaStatus } = this.props;
        if (!userId) {
            return;
        }

        const authToken =
            typeof window !== 'undefined' ? window.localStorage.getItem('token') : null;
        if (!authToken || !String(authToken).trim()) {
            this.setState({ verificadoMfa: false });
            return;
        }

        // No llamar al BFF sin un TOTP válido: con codigo vacío el core devuelve 400 y ensucia la consola.
        const codigo = (mfaStatus?.codigoDobleAutenticacion || '').trim();
        if (!/^\d{6}$/.test(codigo)) {
            this.setState({ verificadoMfa: false });
            return;
        }

        const data = {
            idUsuario: userId,
            codigo,
        };

        const req = postVerificarMfaUsuarioApi(data);
        req.then(res => {
            this.setState({ verificadoMfa: true })
        }).catch(err => {
            this.setState({ verificadoMfa: false });
        });
    }

    findUserAndFetchToken = (usuarios) => {
        // Buscar el usuario que coincida con el email del seller
        const { seller } = this.props;
        let user = null;

        if (seller?.emailUsuario) {
            user = usuarios.find(u => u.email?.toLowerCase() === seller.emailUsuario?.toLowerCase());
        }

        // Si no se encuentra por email, NO usar fallback ciego.
        // Si no coincide el email, es riesgoso asumir cual es el usuario correcto para el token.

        if (user?.idUsuario) {
            const key = `${user.idUsuario}|${(seller?.emailUsuario || "").toLowerCase()}`;
            if (this._lastFindUserTokenKey === key) {
                return;
            }
            this._lastFindUserTokenKey = key;
            this.fetchTokenUsuario(user.idUsuario);
        }
    }

    fetchTokenUsuario = (idUsuarioOverride = null) => {
        // Usar id pasado o fallback a props (pero props suele ser rancio aquí, preferir override)
        let idUsuario = idUsuarioOverride;

        if (!idUsuario) {
            const { usuario } = this.props;
            if (usuario?.idUsuario) {
                idUsuario = usuario.idUsuario;
            }
        }

        const idUsuarioNum = Number(idUsuario);
        if (!idUsuarioNum || Number.isNaN(idUsuarioNum) || idUsuarioNum <= 0) {
            return;
        }

        const data = { idUsuario: idUsuarioNum };
        const req = postSearchTokenUsuario(data);
        req.then((res) => {
            const token = this.parseResetTokenResponse(res?.data);
            this.setState({ token: token || "" });
        }).catch((err) => {
            const status = err?.response?.status;
            // Si aún no hay token de reset, UsuariosCore suele responder 400; no es fallo de UI ni debe ensuciar la consola.
            if (status === 400) {
                this.setState({ token: "" });
                return;
            }
            console.error("Error fetching token:", err);
            this.setState({ token: "" });
        });
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }



    togglePasswordVisibility = () => {
        this.setState(prevState => ({ showPasswordVisible: !prevState.showPasswordVisible }));
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState(prevState => ({ showConfirmPasswordVisible: !prevState.showConfirmPasswordVisible }));
    };

    onGenerarQR = async (e) => {
        e.preventDefault();

        const { userId, userCredentials } = this.props;

        let requestEnlazarMfa = {
            idUsuario: userId,
            usuario: userCredentials.user,
            password: userCredentials.password
        };

        return enlazarMfaUsuarioApi(requestEnlazarMfa)
            .then((res) => {
                const codigoQrEnlace = res?.codigoQrEnlace;
                const mfaBypass = Boolean(res?.mfaBypass);
                const hasQr = typeof codigoQrEnlace === "string" && codigoQrEnlace.trim().length > 0;

                if (!hasQr) {
                    const mensaje = mfaBypass
                        ? "Este usuario tiene MFA omitido por configuración. No se genera QR."
                        : "No se pudo generar el QR para este usuario.";
                    toast.info(mensaje);
                    this.setState({ codigoQR: null });
                    return false;
                }

                this.setState({ codigoQR: codigoQrEnlace });
                return true;
            });
    };

    onConfirmarMfa = (e) => {
        e.preventDefault();

        const { userId } = this.props;
        const { codigoDobleAutenticacion } = this.state;

        const requestConfirmarMfa = {
            idUsuario: userId,
            codigo: codigoDobleAutenticacion,
        };

        if (!codigoDobleAutenticacion.trim()) {
            toast.error("El código no puede estar vacío");
            this.setState({ codigoDobleAutenticacion: "" });
            return;
        }

        const regexCodigo = /^\d{6}$/;
        if (!regexCodigo.test(codigoDobleAutenticacion)) {
            toast.error("El código debe contener exactamente 6 dígitos numéricos");
            this.setState({ codigoDobleAutenticacion: "" });
            return;
        }

        confirmarMfaApi(requestConfirmarMfa)
            .then(() => {
                toast.success("Código confirmado correctamente");

                setTimeout(() => {
                    if (this.modalInstance) {
                        this.modalInstance.hide();
                    }

                    this.setState({
                        codigoDobleAutenticacion: ""
                    });

                    this.props.setMfaStatus(true, true);
                }, 2000);
            })
            .catch((error) => {
                toast.error("El código ingresado es incorrecto");

                this.setState({
                    codigoDobleAutenticacion: ""
                });
            });
    };

    handleChange = (e) => {
        this.setState({ codigoDobleAutenticacion: e.target.value });
    };

    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    handlePasswordChange = (event) => {
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    };

    handleConfirmPasswordChange = (event) => {
        this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));

        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    };

    render() {
        let { seller, mfaStatus, userId, usuario } = this.props;

        return (
            <div className="form-horizontal form-material   p-10" autoComplete="off">
                <div className="tab-content">
                    <div className="tab-pane p-4 active" name="datos" id="home2" role="tabpanel">

                        <div className="card border shadow-sm mb-4">
                            <div className="card-header bg-light">
                                <h5 className="mb-0 text-dark">Datos de Cuenta</h5>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="emailUsuarioMailUsuario" className="form-label fw-bold small text-secondary">Email Usuario</label>
                                            <input
                                                id="emailUsuarioMailUsuario"
                                                type="text"
                                                className="form-control"
                                                value={seller.emailUsuario || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="usuario@dominio.com"
                                                name="emailUsuario"
                                                ref={this.emailUsuarioInputRef}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="nombreUsuarioMailUsuario" className="form-label fw-bold small text-secondary">Nombre de Usuario</label>
                                            <input
                                                id="nombreUsuarioMailUsuario"
                                                type="text"
                                                className="form-control"
                                                value={seller.nombreUsuario || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="Nombre Usuario"
                                                name="nombreUsuario"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="nuevoPasswordMailUsuario" className="form-label fw-bold small text-secondary">Nueva contraseña</label>
                                            <div className="input-group">
                                                <input
                                                    id="nuevoPasswordMailUsuario"
                                                    type={this.state.showPasswordVisible ? "text" : "password"}
                                                    className="form-control"
                                                    value={this.props.seller.password || ""}
                                                    onChange={this.handlePasswordChange}
                                                    name="password"
                                                    autoComplete="new-password"
                                                    maxLength={12}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={this.togglePasswordVisibility}
                                                >
                                                    <IconEye isHidden={this.state.showPasswordVisible} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="confirmarPasswordMailUsuario" className="form-label fw-bold small text-secondary">Confirmar contraseña</label>
                                            <div className="input-group">
                                                <input
                                                    id="confirmarPasswordMailUsuario"
                                                    type={this.state.showConfirmPasswordVisible ? "text" : "password"}
                                                    className={this.state.usuarioError ? "warning-input form-control" : "form-control"}
                                                    value={this.props.seller.confirmarPassword || ""}
                                                    onChange={this.handleConfirmPasswordChange}
                                                    name="confirmarPassword"
                                                    maxLength={12}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={this.toggleConfirmPasswordVisibility}
                                                >
                                                    <IconEye isHidden={this.state.showConfirmPasswordVisible} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <small className="text-muted d-block mb-2">Requisitos de seguridad:</small>
                                        <PasswordValidation
                                            password={this.props.seller.password || ""}
                                            isValidPassword={this.handlePassValidation}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {seller?.codigo ? (
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="card border shadow-sm">
                                    <div className="card-header bg-light">
                                        <h5 className="mb-0 text-dark">Doble factor de autenticacion</h5>
                                    </div>
                                    <div className="card-body">
                                        {userId && (
                                            <>
                                                {mfaStatus?.mfaHabilitado && mfaStatus?.mfaConfirmado ? (
                                                    <div className="d-flex align-items-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-success waves-effect waves-light px-4 py-2"
                                                            style={{ cursor: 'default', fontSize: '1.1rem' }}
                                                        >
                                                            Activado
                                                        </button>
                                                        <a
                                                            href="/manual_mfa.html"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-secondary btn-sm rounded-pill px-3 ms-2 text-decoration-none"
                                                            style={{ marginLeft: '10px' }}
                                                            title="Ayuda"
                                                        >
                                                            <i className="mdi mdi-help-circle-outline"></i>
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex flex-column align-items-start">
                                                        <button
                                                            type="button"
                                                            className="btn btn-warning waves-effect waves-light px-4 py-2 mb-3"
                                                            style={{ cursor: 'default', fontSize: '1.1rem' }}
                                                        >
                                                            Desactivado
                                                        </button>
                                                        <div className="d-flex align-items-center">
                                                            <button
                                                                onClick={(e) => {
                                                                    this.setState({ codigoDobleAutenticacion: "", codigoQR: null }, () => {
                                                                        this.onGenerarQR(e).then((qrGenerado) => {
                                                                            if (!qrGenerado) {
                                                                                return;
                                                                            }
                                                                            const modalElement = document.getElementById("modalQrMfa");
                                                                            this.modalInstance = new Modal(modalElement);
                                                                            this.modalInstance.show();
                                                                        });
                                                                    });
                                                                }}
                                                                className="btn btn-large background-rojo-megatone rounded-sm"
                                                            >
                                                                Generar QR
                                                            </button>
                                                            <a
                                                                href="/manual_mfa.html"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary btn-sm rounded-pill px-3 ms-2 text-decoration-none"
                                                                style={{ marginLeft: '10px' }}
                                                                title="Ayuda"
                                                            >
                                                                <i className="mdi mdi-help-circle-outline"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        ) : null}

                            <div className="modal fade" id="modalQrMfa" tabIndex="-1" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content text-center px-4 pt-3 pb-4">
                                        <div className="text-end">
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Cerrar"
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            <p className="mb-3 fw-bold">Escaneá este QR con tu app de autenticación</p>
                                            {this.state.codigoQR && (
                                                <img
                                                    src={`data:image/png;base64,${this.state.codigoQR}`}
                                                    alt="QR de autenticación"
                                                    style={{ width: 256, height: 256 }}
                                                    className="mb-3"
                                                />
                                            )}
                                            <small className="text-muted d-block mb-3">
                                                Si no tenés la app, descargá <a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" rel="noopener noreferrer">
                                                    Microsoft Authenticator para Android
                                                </a> o <a href="https://apps.apple.com/app/microsoft-authenticator/id983156458" target="_blank" rel="noopener noreferrer">
                                                    iOS
                                                </a>.
                                            </small>

                                            <input
                                                name="codigoDobleAutenticacion"
                                                type="text"
                                                className="form-control mb-3 text-center"
                                                placeholder="Ingresá el código de 6 dígitos"
                                                onChange={this.handleChange}
                                                maxLength={6}
                                                value={this.state.codigoDobleAutenticacion}
                                                autoComplete="one-time-code"
                                            />

                                            <button
                                                onClick={this.onConfirmarMfa}
                                                className="btn btn-large background-rojo-megatone rounded-sm"
                                            >
                                                Enviar código
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </div>
                </div>
            </div>
        );
    }
}
MailUsuario.propTypes = {
    // Redux props
    seller: PropTypes.shape({
        codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idTipoUsuario: PropTypes.number,
        emailUsuario: PropTypes.string,
        nombreUsuario: PropTypes.string,
        password: PropTypes.string,
        passwordActual: PropTypes.string,
        confirmarPassword: PropTypes.string,
    }),
    usuarios: PropTypes.array,
    usuario: PropTypes.shape({
        idUsuario: PropTypes.number,
    }),
    mfaStatus: PropTypes.shape({
        codigoDobleAutenticacion: PropTypes.string,
        mfaHabilitado: PropTypes.bool,
        mfaConfirmado: PropTypes.bool,
    }),
    userCredentials: PropTypes.shape({
        user: PropTypes.string,
        password: PropTypes.string,
    }),
    userId: PropTypes.number,
    // Actions props
    fetchUsuario: PropTypes.func,
    editSeller: PropTypes.func,
    setMfaStatus: PropTypes.func,
}

const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    tipoUsuario: state.general.tipoUsuario,
    usuario: JSON.stringify(state.usuarios.user) != "{}" ? state.usuarios.user : state.usuarios.usuario,
    idSeller: state.general.idSeller,
    usuarios: state.usuarios.usuarios,
    userId: state.general.userId,
    userCredentials: state.general.userCredentials,
    mfaStatus: state.general.mfaStatus,
});

export default connect(mapStateToProps, {
    editSeller, fetchSeller, fetchUsuarios, setMfaStatus, editUsuario, fetchUsuario
})(MailUsuario);
